import { ExperimentId } from '../../../common/experiments/experimentsConstants';
import { ImMNUser } from '../../../common/users/userModelTypes';
import { isFeatureEnabled } from '../../../common/users/utils/userPropertyUtils';

export const tagsFeaturePredicate = ({ currentUser }: { currentUser: ImMNUser }) => {
    return isFeatureEnabled(ExperimentId.tags, currentUser);
};
